import dayjs, { Dayjs } from 'dayjs';
import { REPEAT_VALUE } from '../../../../constants';
import { CellBooking } from '../../../../types/meetingRoomTable';

// For repeated bookings, use the occurrence date based on the cell date
export const getOccurrenceDate = (booking: CellBooking, cellDate?: Dayjs): string => {
    if (booking.repeatEndDate && cellDate) {
        const repeatStart = dayjs(booking.date);
        const repeatEnd = dayjs(booking.repeatEndDate);
        const targetDate = cellDate.startOf('day');

        if (
            targetDate.isSame(repeatStart) ||
            (targetDate.isAfter(repeatStart) && targetDate.isBefore(repeatEnd)) ||
            targetDate.isSame(repeatEnd)
        ) {
            return targetDate.format('YYYY-MM-DD');
        }
    }
    return booking.date;
};

export const parseBookingTime = (
    booking: CellBooking,
    timeKey: 'startTime' | 'endTime',
    cellDate?: Dayjs,
): dayjs.Dayjs => {
    const occurrenceDate = getOccurrenceDate(booking, cellDate);
    return dayjs(`${occurrenceDate} ${booking[timeKey]}`);
};

export const calculateHeightPercentage = (start: dayjs.Dayjs, end: dayjs.Dayjs): number =>
    (end.diff(start, 'minute') / 60) * 100;

export const getRepeatValueLabel = (repeatValue?: REPEAT_VALUE | null): string => {
    if (repeatValue === REPEAT_VALUE.DAY) return 'Daily';
    if (repeatValue === REPEAT_VALUE.WEEK) return 'Weekly';
    if (repeatValue === REPEAT_VALUE.MONTH) return 'Monthly';
    return '';
};
